import React from 'react';
import { filterColors } from '@utils';
import { StyledRow } from './styled';

function Row({ cells, rowIndex }) {
  const color = filterColors[rowIndex];
  return (
    <StyledRow key={rowIndex} color={color}>
      {cells}
    </StyledRow>
  );
}

export default Row;
